export default {
  TITLE_DOSE_NOT_EXIST: "عنوان وارد نشده است.",
  TITLE_INVALID: "عنوان نامعتبر است.",

  PATTERN_DOSE_NOT_EXIST: "الگو صفحه وارد نشده است.",
  PATTERN_INVALID: "الگو صفحه نامعتبر است.",

  LINK_DOSE_NOT_EXIST: "لینک صفحه  وارد نشده است.",
  LINK_INVALID: "لینک صفحه  نامعتبر است.",

  PRICE_DOSE_NOT_EXIST: "قیمت وارد نشده است.",
  PRICE_INVALID: "قیمت نامعتبر است.",

  FILE_DOSE_NOT_EXIST: "عکس صفحه نامعتبر است.",
  FILE_INVALID: "عکس صفحه نامعتبر است.",

  ACTIVE_DOSE_NOT_EXIST: "فعال وارد نشده است.",
};
